import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface DiscussionsSkeletonProps {
  count?: number;
}

const DiscussionSkeletonItem = () => {
  return (
    <Card className="bg-ihs-accent-blue shadow-sm outline-none border-none rounded-lg p-4 h-[180px] flex flex-col">
      <CardContent className="px-0 py-0 flex flex-col space-y-4 h-full">
        <Skeleton className="h-9 w-9 rounded-full" />
        <Skeleton className="h-4 w-full mb-2" />
        <Skeleton className="h-6 w-full mb-2" />
      </CardContent>
    </Card>
  );
};

export const DiscussionsSkeleton = (
  { count = 9 }: DiscussionsSkeletonProps = { count: 4 }
) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <DiscussionSkeletonItem key={index} />
      ))}
    </>
  );
};
